import { useCallback, useRef } from 'react';

// Une liste relue à chaque filtre, page ou retour lance plusieurs lectures qui
// peuvent se croiser: une réponse plus lente (souvent le premier chargement,
// sans filtre) arrivait après la bonne et la remplaçait. Le filtre semblait
// « prendre puis lâcher », avec un total et des pages qui ne lui allaient plus.
//
// `nouvelleDemande()` ouvre une lecture et rend `perimee()`: vrai dès qu'une
// lecture plus récente a été lancée. La réponse périmée n'écrit rien.
//
//   const nouvelleDemande = useDerniereDemande();
//   const charger = useCallback(async () => {
//     const perimee = nouvelleDemande();
//     const page = await api.liste(params);
//     if (perimee()) return;
//     setLignes(page.items);
//   }, [params, nouvelleDemande]);
export function useDerniereDemande() {
  const derniere = useRef(0);
  return useCallback(() => {
    const numero = ++derniere.current;
    return () => numero !== derniere.current;
  }, []);
}

export default useDerniereDemande;
